import { Navigate, useMatches } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminLayout from './Admin';
import FullLayout from './Full';

const layouts = {
  admin: AdminLayout,
  full: FullLayout,
};

const Layout = ({ children }) => {
  const matches = useMatches();
  console.log('matches', matches);
  const last = matches[matches.length - 1];
  const layout = last.data?.layout || 'admin';
  const role = useSelector((state) => state.account.memberRole || 'viewer');
  if (last.data?.auth && !last.data.auth.includes(role)) {
    return <Navigate to="/" />;
  }

  const Component = layouts[layout] || AdminLayout;

  return (
    <Component>{children}</Component>
  );
};

export default Layout;
